import { erpAxios } from '.';

const getOdborGrupe = async () => {
  const { data } = await erpAxios.get('/odborGrupe');
  return data;
};

export default getOdborGrupe;
